import {useCallback} from "react";

import type CourseModule from "./CourseModule";
import type FetchStatus from "../FetchStatus";
import {useAppSelector} from "../hooks";
import {keyProvider} from "../keyProvider";
import type ModulesState from "./ModulesState";
import type {RootState} from "../store";

const empty: CourseModule[] = [];

function createAvailableModulesHook(select: (s: RootState) => ModulesState) {
	return function useAvailableModules(
		courseId: number
	): [CourseModule[], (module: string) => boolean, FetchStatus, boolean] {
		const key = keyProvider.course(courseId);

		const modules = useAppSelector(
			(state) => select(state).byKey[key]?.modules ?? empty
		);

		const fetchStatus = useAppSelector(
			(state) => select(state).byKey[key]?.status ?? "none"
		);

		const available = useCallback(
			(module: string) => Boolean(modules.find((m) => m.name === module)),
			[modules]
		);

		const awaiting = fetchStatus === "none" || fetchStatus === "pending";

		return [modules, available, fetchStatus, awaiting];
	};
}

export default createAvailableModulesHook;
